// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"5479":"b19bb45c","8456":"375a538c"}[chunkId] || chunkId) + "." + {"3022":"81bbe34e255c4a51","4502":"62e3b3d691fc6959","5479":"8e0ed465f2d0cf0c","8456":"5ee9acc52b7b6b5e"}[chunkId] + ".js";
};